(function () {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };

  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  async function refreshCount() {
    const cart = await fetch('/cart.js').then(r => r.json());
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
  }

  async function addToCart(id, quantity = 1) {
    const res = await fetch(window.MargTheme.cartAddUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || 'Could not add to bag');
    await refreshCount();
    return data;
  }

  // Mobile menu
  const toggle = $('[data-menu-toggle]'), menu = $('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => menu.classList.toggle('is-open'));
    document.addEventListener('click', (e) => { if (menu.classList.contains('is-open') && !menu.contains(e.target) && !toggle.contains(e.target)) menu.classList.remove('is-open'); });
  }

  // Slideshow
  $$('[data-slideshow]').forEach(root => {
    const slides = $$('.hero__slide', root), bars = $$('.hero__bar', root);
    if (slides.length < 2) return;
    const time = (parseInt(root.dataset.autoplay, 10) || 6) * 1000;
    root.style.setProperty('--slide-time', time + 'ms');
    let i = 0, timer;
    const go = (n) => {
      slides[i].classList.remove('is-active'); bars[i] && bars[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (bars[i]) { void bars[i].offsetWidth; bars[i].classList.add('is-active'); }
      clearTimeout(timer); timer = setTimeout(() => go(i + 1), time);
    };
    bars.forEach((b, n) => b.addEventListener('click', () => go(n)));
    timer = setTimeout(() => go(1), time);
  });

  // Tabs
  $$('[data-tabs]').forEach(root => {
    $$('[data-tab]', root).forEach(btn => btn.addEventListener('click', () => {
      $$('[data-tab]', root).forEach(b => b.classList.toggle('is-active', b === btn));
      $$('[data-panel]', root).forEach(p => p.classList.toggle('is-active', p.dataset.panel === btn.dataset.tab));
    }));
  });

  // Drag-scroll sliders
  $$('[data-drag-scroll]').forEach(el => {
    let down = false, x = 0, left = 0;
    el.addEventListener('mousedown', e => { down = true; x = e.pageX; left = el.scrollLeft; });
    window.addEventListener('mouseup', () => down = false);
    el.addEventListener('mousemove', e => { if (!down) return; e.preventDefault(); el.scrollLeft = left - (e.pageX - x); });
  });

  // Quick add
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    try { await addToCart(btn.dataset.quickAdd); toast('Added to your bag'); }
    catch (err) { toast(err.message); }
  });

  // Product page
  $$('[data-product]').forEach(root => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-btn]', root);
    const priceEl = $('[data-price]', root);
    const msg = $('[data-form-msg]', root);

    const showMedia = (id) => {
      $$('.pdp__slide', root).forEach(s => s.classList.toggle('is-active', String(s.dataset.mediaId) === String(id)));
      $$('.pdp__thumb', root).forEach(t => t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)));
    };
    $$('[data-thumb]', root).forEach(t => t.addEventListener('click', () => showMedia(t.dataset.thumb)));

    const update = () => {
      const selected = $$('fieldset.option', root).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
      $$('[data-option-label]', root).forEach((l, n) => l.textContent = selected[n] || '');
      const variant = product.variants.find(v => v.options.every((o, n) => o === selected[n]));
      if (!variant) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
      priceEl.innerHTML = (variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s>' : '') + '<span>' + money(variant.price) + '</span>';
      if (variant.featured_media) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };
    $$('fieldset.option input', root).forEach(i => i.addEventListener('change', update));

    $$('[data-qty]', root).forEach(b => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', root);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
    }));

    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      addBtn.disabled = true; msg.textContent = '';
      try {
        await addToCart(idInput.value, $('input[name="quantity"]', root).value);
        msg.innerHTML = 'Added to your bag. <a class="link-underline" href="' + window.MargTheme.cartUrl + '">View bag</a>';
        toast('Added to your bag');
      } catch (err) { msg.textContent = err.message; }
      addBtn.disabled = false;
    });
  });

  // Recommendations
  $$('[data-recommendations]').forEach(async el => {
    if (el.children.length) return;
    try {
      const html = await fetch(el.dataset.url).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner) el.innerHTML = inner.innerHTML;
    } catch (e) {}
  });
})();
